import { RestPath } from "../../../../constants/SitePaths";
export const IdentificationEnum = {
    IDENTIFY_CUPIS_CLIENT: RestPath.IDENTIFY_CUPIS_CLIENT,
    GET_CUPIS_CLIENT_INN: RestPath.GET_CUPIS_CLIENT_INN,
    EDIT_CUPIS_CLIENT_BIRTHDATE: RestPath.EDIT_CUPIS_CLIENT_BIRTHDATE
}

export const IdentificationV2Enum = {
    CUPIS_SIMPLE_IDENTIFY: RestPath.CUPIS_SIMPLE_IDENTIFY,
    VERIFY_CUPIS_PSP: RestPath.VERIFY_CUPIS_PSP,
    VERIFY_FULL_CUPIS_ESIA: RestPath.VERIFY_FULL_CUPIS_ESIA

}

export const IdentificationFlowEnum = {
    None: 0,
    Fast: 1,
    Simple: 2,
    Full: 3,
    EsiaAndSimple: 4,
    EsiaAndFull: 5,
    OTP: 6,
    Verification: 7
}

export const IdentificationTypeEnum = {
    InternalDocuments: 1,
    KYCAID: 2,
    Metamap: 3,
}

export default IdentificationEnum